import * as React from 'react';
import { useReactTable, getSortedRowModel, getExpandedRowModel, getFilteredRowModel, getFacetedRowModel, getFacetedUniqueValues, getPaginationRowModel } from '@tanstack/react-table';

const useTable = (props) => {
    const { data, state, pageCount, manualPagination, columns, enableGlobalFilter = false, ...restOptions } = props;
    const [expanded, setExpanded] = React.useState({});
    const [sorting, setSorting] = React.useState([]);
    const [columnFilters, setColumnFilters] = React.useState([]);
    const table = useReactTable({
        data,
        columns,
        pageCount,
        state: {
            expanded,
            sorting,
            columnFilters,
            ...state,
        },
        autoResetPageIndex: false,
        getSortedRowModel: getSortedRowModel(),
        getExpandedRowModel: getExpandedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getFacetedRowModel: getFacetedRowModel(),
        getFacetedUniqueValues: getFacetedUniqueValues(),
        getPaginationRowModel: !manualPagination ? getPaginationRowModel() : undefined,
        onSortingChange: setSorting,
        onExpandedChange: setExpanded,
        onColumnFiltersChange: setColumnFilters,
        manualPagination,
        enableGlobalFilter,
        ...restOptions,
    });
    return table;
};

export { useTable };
//# sourceMappingURL=useTable.js.map
